import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-textarea-config',
  templateUrl: './d-textarea-config.component.html',
  styles: []
})
export class DTextareaConfigComponent extends DynamicComponentBase {
  static KEY = 'd-textarea-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
